export default function ChatBot() {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
          <zapier-interfaces-chatbot-embed is-popup="true" chatbot-id='clpsf1stv0031n26ey4crr9d6' height="600px" width="400px"></zapier-interfaces-chatbot-embed>
          `,
      }}
    ></div>
  );
}
